import React, { useState } from "react";
import { useForm } from "react-hook-form";

import Image from "../../../components/image";
import { useTheme } from "../../../context/ThemeContext";
import signupFeaturedBackground from "../../../images/blog/signup-backgrond.png";
import signupFeaturedImg from "../../../images/blog/signupFormImg.png";
import InfoIcon from "../../../images/icons/info-outline.inline.svg";
import { getSourceImageUrlToCGI } from "../../../utils/base";
import { processForm } from "../../../utils/processForm";
import { StatusComp } from "../../shared/statusComp";

const FeaturedSignupForm = ({ post }) => {
  const {
    peopleDomain,
    planetDomain,
    currentBrand,
    localeLanguage,
    currentSiteMeta
  } = useTheme();

  // console.debug("FeaturedSignupForm", post);
  const [formStatus, setFormStatus] = useState("pending");
  const [tooltipOpen, setTooltipOpen] = useState(0);
  const intlNumber = currentSiteMeta?.contact_details?.international ?? "";

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    defaultValues: {
      newsletter: false
    }
  });

  const onSubmit = async (data) => {
    try {
      /** TODO
       *  -  add location specific data
       *  - update the api to send this location specific data to SF (no idea how or what field on SF will capture the location being enquired about)
       * **/

      const formFields = {
        form_type: "enquiry_form",
        ...data
      };

      setFormStatus("processing");
      await processForm({
        formdata: formFields,
        peopleDomain,
        planetDomain,
        currentBrand,
        localeLanguage
      });

      setFormStatus("success");
      reset();
    } catch (err) {
      console.error("Error requestForm :: ", err);
      setFormStatus("pending");
    }
  };

  const expTexts = {
    processing: "Just a moment...",
    success: "Thank you!"
  };

  const statusTexts = {
    processing: `We're making sure we have everything we need before connecting you with one of our team members!`,
    success: `One of our enrollment managers will be in touch within 12 hours. If you can’t wait to speak to us, you can call us on  <a class="font-bold" href="tel:${intlNumber}" title="${intlNumber}" rel="nofollow">${intlNumber}.</a>`
  };

  const signupImageMain =
    post?.blogLsuImages && post?.blogLsuImages?.length > 0
      ? getSourceImageUrlToCGI({ uri: post?.blogLsuImages[0]?.sourceUrl })
      : signupFeaturedBackground;
  const signupImageInsert =
    post?.blogLsuImages && post?.blogLsuImages?.length > 0
      ? getSourceImageUrlToCGI({ uri: post?.blogLsuImages[1]?.sourceUrl })
      : signupFeaturedImg;
  const signupTitle = post?.blogLsuTitle ?? "";

  return (
    <div
      className="relative bg-center bg-cover featured-singup-section w-full sm:min-h-[18rem] min-h-[30rem]"
      style={{ backgroundImage: `url('${signupImageMain}')` }}
    >
      <div className="absolute flex flex-col items-end w-full px-0 pt-4 mx-auto sm:items-center sm:px-2 centering sm:w-10/12 sm:flex-row sm:pt-0">
        <div className="hidden w-5/12 h-[23rem] sm:block contact-img drop-shadow-5xl">
          <Image
            imageAlt={"Start your conservation"}
            image={""}
            imageClass="object-cover w-full h-full"
            sourceUrl={signupImageInsert}
          />
        </div>
        <div className="sm:w-7/12 w-11/12 translate-y-[5.5rem] px-8 py-5 dark:bg-white bg-yellow-standard dark:bg-opacity-15 backdrop-blur-[50px] rounded-xxs border-none dark:border-0.5 dark:border-solid dark:border-gray-testimonial ">
          <div className="absolute flex justify-center items-center text-center -right-[2vw] sm:-top-[2vw] -top-[4rem] w-[95px] h-[95px] dark:bg-gray-darker bg-white rounded-full dark:border-white border-black-lighter border dark:text-white text-black-lighter px-2">
            <span className="text-xs">Speak to us about special offers</span>
          </div>
          {formStatus === "pending" ? (
            <form
              id={"featuredSignupForm"}
              className="z-50 w-full text-center md:text-left"
              onSubmit={handleSubmit(onSubmit)}
            >
              <h2
                className={`py-3 font-light text-white text-left sm:w-11/12 sm:leading-[38px] leading-[24px]`}
              >
                {signupTitle}
              </h2>
              <div className="flex flex-wrap justify-between py-2 form-wrapper md:flex-row">
                <label className="w-full md:semi-w-2 relative">
                  <input
                    {...register("first_name", {
                      pattern: /^[^\s].*/,
                      required: true
                    })}
                    placeholder="First Name*"
                    className={`w-full py-2 pl-[17.5px] pr-16 md:pr-8 mb-3 text-base text-white bg-white bg-opacity-9 dark:bg-opacity-100 dark:bg-transparent border focus:outline-0 placeholder:text-base placeholder:font-bold placeholder:bg-transparent rounded-xxs placeholder:text-white border-gray-testimonial/30 ${
                      errors.first_name ? " !border-red-600 " : ""
                    }`}
                  />
                  <div
                    className={`tooltip tooltip-left w-1/6 md:w-5 !absolute py-3 right-0 top-0 md:right-2 before:py-3 before:rounded-xxs before:bg-white before:dark:bg-gray-standard before:text-gray-standard before:dark:text-white tooltip-${tooltipOpen}`}
                    data-tip="This is how we will refer to you."
                  >
                    <InfoIcon
                      onClick={() => setTooltipOpen(1 - tooltipOpen)}
                      className="fill-white dark:fill-white stroke-transparent group-hover:sm:fill-white z-10"
                    />
                  </div>{" "}
                </label>
                {/* register an input */}
                <input
                  {...register("last_name", {
                    pattern: /^[^\s].*/,
                    required: true
                  })}
                  placeholder="Last Name*"
                  className={`w-full py-2 pl-[17.5px] mb-3 text-base text-white bg-white bg-opacity-9 dark:bg-opacity-100 dark:bg-transparent border focus:outline-0 placeholder:text-base placeholder:font-bold placeholder:bg-transparent rounded-xxs placeholder:text-white border-gray-testimonial/30 md:semi-w-2 ${
                    errors.last_name ? " !border-red-600 " : ""
                  }`}
                />
                <input
                  type="number"
                  {...register("phone_number", {
                    pattern: /\d+/,
                    required: true
                  })}
                  placeholder="Phone*"
                  className={`w-full py-2 pl-[17.5px] mb-3 text-base text-white bg-white bg-opacity-9 dark:bg-opacity-100 dark:bg-transparent border focus:outline-0 placeholder:text-base placeholder:font-bold placeholder:bg-transparent rounded-xxs placeholder:text-white border-gray-testimonial/30 md:semi-w-2 ${
                    errors.phone_number ? " !border-red-600 " : ""
                  }`}
                />
                <input
                  {...register("email_address", {
                    required: true,
                    pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
                  })}
                  placeholder="Email*"
                  className={`w-full py-2 pl-[17.5px] mb-3 text-base text-white bg-white bg-opacity-9 dark:bg-opacity-100 dark:bg-transparent border focus:outline-0 placeholder:text-base placeholder:font-bold placeholder:bg-transparent rounded-xxs placeholder:text-white border-gray-testimonial/30 md:semi-w-2 ${
                    errors.email_address ? " !border-red-600 " : ""
                  }`}
                />
                <p className="text-xs text-left text-white">
                  By clicking &quot;Enquire or Request a callback&quot; below, I
                  have read and accepted GVI&apos;s{" "}
                  <a
                    href="/privacy"
                    target="_blank"
                    className="text-white border-b border-white dark:sm:border-white font-semi-bold dark:border-b-white hover:border-b-yellow-standard dark:hover:border-green-standard hover:text-yellow-standard dark:hover:!text-green-standard active:border-b-yellow-standard dark:active:border-green-standard active:text-yellow-standard dark:active:!text-green-standard"
                  >
                    Privacy Policy
                  </a>
                  . In opening hours, you will be contacted by us within a few
                  minutes.
                </p>
                <label
                  htmlFor="newsletter"
                  className="relative mt-[9px] text-left flex items-center text-xs text-white custom-checkbox"
                >
                  <input
                    type="checkbox"
                    {...register("newsletter")}
                    id="newsletter"
                    value={"newsletter_signup"}
                  />
                  <div className="hidden hidden-fields">
                    <input
                      type="hidden"
                      defaultValue="privacy_policy"
                      {...register("privacy_policy")}
                    />
                  </div>
                  <span className="checkmark sm:!top-1 2xl:!top-0 w-7.5 sm:w-4.5 h-7.5 sm:h-4.5 bg-transparent border border-gray-testimonial rounded-xxs flex shrink-0 justify-center items-center" />
                  Sign me up for GVI newsletters to receive news and special
                  offers.
                </label>
                <div className="flex justify-center w-full gap-1 pt-4">
                  <button
                    type="submit"
                    className="flex m-auto  sm:w-1/2 w-full py-2 bg-red-light dark:bg-green-standard border dark:border-green-standard border-red-right justify-center items-center rounded-full dark:rounded-xxs"
                  >
                    <span className="text-base pl-2 mr-2 font-bold !text-white dark:!text-gray-darker tracking-[0.02em]">
                      Enquire
                    </span>
                  </button>
                </div>
              </div>
            </form>
          ) : (
            <div className="">
              <StatusComp
                expText={expTexts[formStatus]}
                statusText={statusTexts[formStatus]}
                status={formStatus}
                align="center"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FeaturedSignupForm;
